"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../card/index");
var _index2 = require("../space/index");
var _kDsFoundation = _interopRequireDefault(require("../../lib/k-ds-foundation"));
var _excluded = ["className", "children", "theme", "overlayBackground", "onOverlayClick", "cardType", "showClose", "onClose", "header", "subHeader"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var IconClose = function IconClose(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m7 5.086 4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414L7 7.914l-4.95 4.95L.636 11.45l4.95-4.95-4.95-4.95L2.05.136 7 5.086Z",
    fill: "#888EA0"
  }));
};
IconClose.defaultProps = {
  width: "14",
  height: "13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var StyledOverlay = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "kds-v1__sc-1v7bmg0-0"
})(["display:flex;", " align-items:center;justify-content:center;position:fixed;top:0;bottom:0;left:0;right:0;z-index:1;", " .modal-header{", " ", ";}.modal-sub-header{", " margin:0;}.icon-close{cursor:pointer;padding:8px;flex-shrink:0;}"], function (props) {
  return !props.isOpen && (0, _styledComponents.css)(["display:none;"]);
}, function (props) {
  return props.overlayBackground && (0, _styledComponents.css)(["background:", ";"], props.overlayBackground);
}, _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-primary'), _kDsFoundation["default"].setSpacingWithFallback('margin: ', 0, 0, 'spacing-03', 0), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-secondary'));
var overlayBackgroundFromTheme = {
  'light': 'rgba(245, 246, 251, 0.96)',
  'dark': 'rgba(24, 34, 61, 0.16)'
};
var Modal = exports.Modal = function Modal(_ref) {
  var className = _ref.className,
    children = _ref.children,
    theme = _ref.theme,
    overlayBackground = _ref.overlayBackground,
    onOverlayClick = _ref.onOverlayClick,
    cardType = _ref.cardType,
    showClose = _ref.showClose,
    onClose = _ref.onClose,
    header = _ref.header,
    subHeader = _ref.subHeader,
    moreProps = _objectWithoutProperties(_ref, _excluded);
  var defaultTheme = 'light';
  // eslint-disable-next-line
  var overlayBg = overlayBackground || overlayBackgroundFromTheme[theme] || overlayBackgroundFromTheme[defaultTheme];
  var headerJustify = !header && showClose ? 'end' : 'space-between';
  var Header = /*#__PURE__*/_react["default"].createElement(_index2.Space, {
    className: "k-ds-width-full",
    direction: "horizontal",
    align: "center",
    justify: headerJustify
  }, header ? /*#__PURE__*/_react["default"].createElement("h1", {
    className: "modal-header k-ds-heading-04"
  }, header) : null, showClose ? /*#__PURE__*/_react["default"].createElement(IconClose, {
    className: "icon-close",
    onClick: onClose,
    "aria-hidden": "true"
  }) : null);
  return /*#__PURE__*/_react["default"].createElement(StyledOverlay, _extends({
    overlayBackground: overlayBg,
    onClick: onOverlayClick
  }, moreProps), /*#__PURE__*/_react["default"].createElement(_index.Card, {
    type: cardType,
    className: className,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, header || showClose ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, Header) : null, subHeader ? /*#__PURE__*/_react["default"].createElement("h2", {
    className: "modal-sub-header k-ds-body-01"
  }, subHeader) : null, header || subHeader ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "k-ds-m-bottom-sp-06"
  }) : null, /*#__PURE__*/_react["default"].createElement("div", null, children)));
};